<template>
  <div>
    <modalAddAddress ref="modalAddAddress" @action="saveAddress"></modalAddAddress>
    <ModalDelete ref="ModalDelete" confirm-text="Hapus" @action="deleteAddress">
      <template v-slot:title>
        <span class="primary--text text-capitalize font-weight-bold">Hapus Alamat</span>
      </template>
      <template v-slot:body>
        <div class="text-center">
          Apakah Anda yakin untuk menghapus "
          <span class="text-capitalize">{{ selected_data }}</span>"?
          <br />Anda tidak dapat mengembalikan alamat yang sudah dihapus.
        </div>
      </template>
    </ModalDelete>
    <v-row>
      <v-col cols="12" class="pb-0">
        <div class="d-flex justify-space-between">
          <div class="text-body-2 font-weight-bold my-auto">Informasi Alamat</div>
          <v-btn depressed text class="rounded-lg border" @click="openModalAddAddress()">
            <v-icon color="black">mdi-plus-circle</v-icon>
            <div
              class="pl-2 d-none d-sm-block text-body-2 text-capitalize black--text font-weight-bold"
            >Tambah Alamat</div>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <div v-if="addressData.length > 0">
      <v-row class="d-none d-md-flex">
        <v-col cols="12" md="3">
          <div class="grey--text text--darken-1 text-body-2">Label Alamat</div>
        </v-col>
        <v-col cols="12" md="9">
          <div class="grey--text text--darken-1 text-body-2">Alamat Lengkap</div>
        </v-col>
      </v-row>
      <div v-for="(data, index) in addressData" :key="index">
        <div class="py-2">
          <v-divider></v-divider>
        </div>
        <v-row>
          <v-col cols="12" md="3">
            <div class="text-body-2 font-weight-bold text-capitalize">{{ data.user_address_name }}</div>
          </v-col>
          <v-col cols="12" md="9" class="pt-0 pt-sm-3">
            <v-row>
              <v-col md="7" class="py-0">
                <div
                  class="text-body-2 font-weight-bold text-capitalize"
                >{{ data.user_address_receipt_name }}</div>
                <div class="pt-2 pt-sm-1 text-body-2">{{ addressText(data) }}</div>
                <div class="pt-1 text-body-2">
                  <span>Telepone/Handphone :</span>
                  <span class="pl-1">{{ data.user_address_mobilephone }}</span>
                </div>
                <div
                  class="pt-1 text-body-2"
                  v-if="data.user_address_latitude!='' && data.user_address_longitude!=''"
                >
                  <span>Lat/Long :</span>
                  <span class="pl-1">
                    <a
                      target="_blank"
                      :href="'http://www.google.com/maps/place/'+data.user_address_latitude+','+data.user_address_longitude"
                    >{{ data.user_address_latitude }} / {{ data.user_address_longitude }}</a>
                  </span>
                </div>
              </v-col>
              <v-col md="5" class="pb-0 py-sm-0">
                <div class="d-flex justify-end">
                  <div>
                    <v-btn
                      v-if="data.user_address_is_used == 'used'"
                      small
                      width="194"
                      outlined
                      color="success"
                      class="rounded-lg"
                    >
                      <v-icon small>mdi-check-circle</v-icon>
                      <div class="pl-1 text-body-2 text-capitalize font-weight-bold">Alamat Utama</div>
                    </v-btn>
                    <v-btn
                      v-else
                      @click="setDefault(data.user_address_id)"
                      small
                      outlined
                      color="grey darken-1"
                      class="rounded-lg"
                    >
                      <div class="text-body-2 text-capitalize font-weight-bold">Jadikan Utama</div>
                    </v-btn>
                  </div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        text
                        class="ml-2 rounded-lg"
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="openModalAddAddress(data)"
                      >
                        <v-icon color="#272727" dark>mdi-pencil-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="data.user_address_is_used != 'used'">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="ml-2 rounded-lg"
                        small
                        outlined
                        color="pink lighten-2"
                        v-bind="attrs"
                        v-on="on"
                        @click="openModalDelete(data)"
                      >
                        <v-icon dark>mdi-delete-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Hapus</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
    <div v-else>
      <div class="pt-3">
        <v-row class="justify-center">
          <v-col cols="7" md="3">
            <v-img width="100%" src="/assets/icons/ilus-alamat-kosong.svg"></v-img>
          </v-col>
        </v-row>
        <div class="text-center pb-3">
          <div class="pt-1 text-body-1 font-weight-bold">Belum ada alamat tersedia</div>
          <div class="pt-1 text-body-2">Silakan tambahkan Alamat Anda</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import modalAddAddress from "@/views/store/cart/ModalAddAddressV2";
import ModalDelete from "@/components/ModalDelete";

export default {
  components: {
    modalAddAddress,
    ModalDelete
  },
  data() {
    return {
      selected_data: ""
    };
  },
  computed: {
    ...mapState("addressKiriminaja", ["addressData"])
  },
  methods: {
    ...mapActions("addressKiriminaja", [
      "getAddress",
      "addAddress",
      "setDefaultAddress",
      "updateAddress",
      "removeAddress"
    ]),
    // ...mapActions('options', ['getCity', 'getSubdistrict']),
    ...mapActions("kiriminaja", ["getCity", "getSubdistrict"]),

    addressText(value) {
      var data = [];
      if (value.user_address_detail) data.push(value.user_address_detail);
      if (value.user_address_subdistrict_name)
        data.push(value.user_address_subdistrict_name);
      if (value.user_address_city_name) data.push(value.user_address_city_name);
      if (value.user_address_province_name)
        data.push(value.user_address_province_name);
      return data.join(", ");
    },
    async openModalAddAddress(data) {
      if (data) {
        await this.getCity({
          province_id: data.user_address_province_id
        });
        await this.getSubdistrict({
          city_id: data.user_address_city_id
        });
        await this.$refs.modalAddAddress.modalShow(data);
      } else {
        this.$refs.modalAddAddress.modalShow();
      }
    },
    openModalDelete(data) {
      this.selected_data = data.user_address_name;
      this.$refs.ModalDelete.modalShow(data);
    },
    saveAddress(address) {
      if (address.id) {
        this.updateAddress(address)
          .then(() => {
            this.getAddress();
          })
          .catch(error => {
            console.log("error", error);
          });
      } else {
        this.addAddress(address).then(() => {
          this.getAddress();
        });
      }
    },
    deleteAddress(data) {
      this.removeAddress({
        id: data.user_address_id
      }).then(() => {
        this.getAddress();
      });
    },
    setDefault(id) {
      this.setDefaultAddress({
        id: id
      }).then(() => {
        this.getAddress();
      });
    }
  }
};
</script>